'use client';

type PdfViewerSectionProps = {
  title?: string;
  pdf_file: string;
  add_background?: boolean;
  add_bottom_border?: boolean;
};

export default function PdfViewerSection({
  title,
  pdf_file,
  add_background = false,
  add_bottom_border = false,
}: PdfViewerSectionProps) {
  // Construct the full PDF URL if it's a relative path
  const getPdfUrl = (file: string) => {
    if (file.startsWith('http://') || file.startsWith('https://')) {
      return file;
    }
    // Handle both formats: with or without leading slash
    const cleanPath = file.startsWith('/') ? file : `/${file}`;
    return cleanPath;
  };

  const pdfUrl = getPdfUrl(pdf_file);

  const content = (
    <div className={`flex flex-col gap-4 ${add_bottom_border ? 'pb-8 border-b border-gray-200' : ''}`}>
      {title && (
        <h2 className="text-3xl md:text-3xl font-bold text-primary-700 mb-4">
          {title}
        </h2>
      )}
      <div className="w-full">
        <iframe
          src={pdfUrl}
          className="w-full h-[800px] border border-gray-200 rounded-lg"
          title={title || 'PDF Viewer'}
        />
      </div>
    </div>
  );

  if (add_background) {
    return (
      <section
        className="
          w-screen relative left-1/2 right-1/2 -mx-[40vw]
          bg-[linear-gradient(to_bottom,rgba(237,237,249,0),#DEE5E8)]
          my-8 py-8
        "
      >
        <div className="bg-[url('/images/left-corner-supergrafis.png')] bg-no-repeat bg-left-bottom bg-[length:400px] py-8">
          <div className="container max-w-7xl mx-auto items-start gap-8 flex">
            <div className="flex-1 min-w-0 px-10">
              {content}
            </div>
            <div className="w-80 flex-shrink-0 lg:block"></div>
          </div>
        </div>
      </section>
    );
  }

  return <div className="w-full">{content}</div>;
}
